// 获取热门游戏
export const GET_HOTGAME = 'GET_HOTGAME';
// 获取游戏分类列表
export const GET_GAME_CATEGORIES = 'GET_GAME_CATEGORIES';
// 获取当前页的游戏列表
export const GET_GAME_LIST = 'GET_GAME_LIST'
// 获取各个游戏平台的banner
export const GET_BANNERS_FOR_GAME = 'GET_BANNERS_FOR_GAME';
// 重置游戏平台密码
export const MODIFY_PLATFORM_PASSWORD = 'MODIFY_PLATFORM_PASSWORD';
// 获取平台开始游戏的地址
export const GET_PLATFORM_PLAYURL = 'GET_PLATFORM_PLAYURL';